export const molsonMenuStyles = {
  '&': { marginTop: '8px' },
  '& div:nth-of-type(3)': {
    borderRadius: '8px'
  },
  '& ul': {
    paddingBlock: 0
  }
}

export const molsonMenuItemStyles = {
  display: 'flex',
  gap: '32px',
  justifyContent: 'space-between',
  padding: '16px'
}
